import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined'

export const AccountIcon = PeopleOutlinedIcon
export default AccountIcon
